import { useTheme, Skeleton, Stack } from '../../../../base';
import {
    IClientSourceOfHireStats,
    IFetchSourceOfHireParams,
} from '../../../../common';
import Top3Section from '../Top3Section';
import HiringSourcesTable from '../../../Tables/HiringSourcesTable';

interface ITableViewProps {
    stats: IClientSourceOfHireStats | null;
    isLoadingStats: boolean;
    reportFilter: IFetchSourceOfHireParams;
}

const TableView = ({
    stats,
    isLoadingStats,
    reportFilter,
}: ITableViewProps) => {
    const theme = useTheme();

    return (
        <>
            {isLoadingStats || !stats ? (
                <Stack sx={{ padding: theme.spacing(2, 3) }}>
                    <Skeleton
                        variant="rectangular"
                        height={110}
                        sx={{ borderRadius: 2 }}
                    />
                </Stack>
            ) : (
                <Top3Section stats={stats} />
            )}
            <HiringSourcesTable reportFilter={reportFilter} />
        </>
    );
};

export default TableView;
